import ActionMenu from "../../components/ui/ActionMenu";

// 레거시 래퍼: 새 코드는 components/ui 의 ActionMenu 를 직접 사용한다.
interface BasicMenuProps {
  isOpen: boolean;
  anchorEl: HTMLElement | null;
  buttons: BasicMenuButton[];
  handleOnClose: () => void;
}

export interface BasicMenuButton {
  title: string;
  isWarning?: boolean;
  handleOnClose: () => void;
}

export default function BasicMenu(props: BasicMenuProps) {
  return (
    <ActionMenu
      open={props.isOpen}
      anchorEl={props.anchorEl}
      onClose={props.handleOnClose}
      // 기존 동작과 같이, 항목의 핸들러가 메뉴 닫기를 직접 처리한다
      closeOnSelect={false}
      items={props.buttons.map((button) => ({
        label: button.title,
        destructive: button.isWarning,
        onSelect: button.handleOnClose,
      }))}
    />
  );
}
